import {
  CANDY_MACHINE_INTERNAL_USERS_KEY_VALUE_STORE,
  CANDY_MACHINE_BOT_BADGE_ADDRESS,
  DCKSLAP_COMPONENT_ADDRESS,
  DCKSLAP_RESOURCE_ADDRESS,
  DCKSLAP_USER_BADGE_RESOURCE_ADDRESS,
  RADIX_API_GATEWAY_URL,
  REDDICKS_DEX_ROUTER_COMPONENT,
  REDDICKS_RESSOURCE_ADDRESS,
} from "../../constants";
import { DEX_SITE_URL } from "../../config/siteContent";

const RADXPLORER_DCKSLAP_URL = "https://www.radxplorer.com/api/dckslap/dckslap";
const RADXPLORER_GBOF_URL = "https://www.radxplorer.com/api/dckslap/gbof";
const GATEWAY_TRANSACTION_STREAM_URL = `${RADIX_API_GATEWAY_URL}/stream/transactions`;
const OCISWAP_POOLS_URL = "https://api.ociswap.com/pools";
const REDDICKS_DEX_PAIRS_URL = `${DEX_SITE_URL}/api/pairs`;
const getReddicksDexPairsCandidateUrls = () => [REDDICKS_DEX_PAIRS_URL];

const VERIFIED_OCISWAP_DCKS_POOL_COMPONENTS = [
  "component_rdx1crq9pmg0ffuc2rz3t7gu40spr29734u0wv6fgw85cnzjv7e2qhgar8",
  "component_rdx1czz6twgrdth69pz2dqy3t384xnflkums9a76udp3l6xnhjqtqm9crh",
  "component_rdx1cp94wskzz62m900nwjlwc2yt7p7calm3jhkl99mly3a8txdcmzt4pr",
  "component_rdx1cpr4qrshyqtwgh6t7lxetafnapkd4lz9330m0xua5q066z5h9y9aq7",
  "component_rdx1cpwwhuxpe2npedx0axkj4nae8uv5222r0syjtu5fxuaxaj78rf30v9",
  "component_rdx1cqakda5xg9urkmh5wrzseclz3d4tum6dmlhqku0hl2zrz3vhyl4p4y",
];
const OCISWAP_DCKS_SEED_STATE_VERSION = 481732872;
const OCISWAP_DCKS_SEED_TRADE_COUNT = 6728;
// Verified DCKS CaviarNine pools as of March 31, 2026.
const VERIFIED_CAVIARNINE_DCKS_SWAP_TARGETS = [
  {
    componentAddress:
      "component_rdx1czjz3qlv377e7ggq6jzfw7zjexs8a7k4854trpec5nlmdy09j35aw3",
    transactionEntityAddress:
      "component_rdx1czjz3qlv377e7ggq6jzfw7zjexs8a7k4854trpec5nlmdy09j35aw3",
  },
  {
    componentAddress:
      "component_rdx1cz7s2xn8ddpmgm3uw0ma4jhaxhxdwce253v9j5agvffhftny6rgh8n",
    transactionEntityAddress:
      "pool_rdx1chmx480a0crrnaqyg2e6tr7wtqwk5239grzs6ecckcmhqjm3gdmm73",
  },
  {
    componentAddress:
      "component_rdx1cqeepy0d9gxstyga95a77e0zzvmkldq5nynpwptuch6en8w6h298u8",
    transactionEntityAddress:
      "pool_rdx1ckxckd5pj5ygx0dq89q2uefm6dujn5wxhfqny36f6jwxqmlqejq7wy",
  },
  {
    componentAddress:
      "component_rdx1cr8fplr4plt7gm0mrec3nlnzxwg7cq388zp47ka7wxx7jkpa6lgw4z",
    transactionEntityAddress:
      "pool_rdx1c426gn63fsu60wtu7thpvfs2wqkfx0hpm78p62scwkn0m37pzgg6xx",
  },
  {
    componentAddress:
      "component_rdx1czk934x864yu9exharr2c4ycx5s9p6gee249fldy5qcmdyq3ycu6n8",
    transactionEntityAddress:
      "pool_rdx1c5xmund8g3jskyes3u3y0jplemxqwzyfwwxs2sm0znm88llh7kg33p",
  },
  {
    componentAddress:
      "component_rdx1crnu7jwm5wrva9gq5xfax3r67afqfzvz4elvkldqqjwqjtwvn87auq",
    transactionEntityAddress:
      "pool_rdx1c565pmzl38g8eppn84hcqyrjn5mgwz03tdmeh28ahst869x8dwxwqj",
  },
  {
    componentAddress:
      "component_rdx1crfjrgda5g8n77euu4gyxtjnu2q5eyqgr9g5pvy9m68vx2jefjwas6",
    transactionEntityAddress:
      "pool_rdx1c5fgq5ft9ny8y7t8eqveqjt72tc5hlne7qkhua9547x8trupm43mkz",
  },
];
const CAVIARNINE_DCKS_SEED_STATE_VERSION = 481732872;
const CAVIARNINE_DCKS_SEED_TRADE_COUNT = 16965;
// Verified from the public DefiPlaza stats pair page surfaced by Astrolescent.
const VERIFIED_DEFIPLAZA_DCKS_PAIR_COMPONENTS = [
  "component_rdx1cq0m4e6gjyekk87lxugtgw6a5cnm7fa60vqn6rpe02hjhfh7tus2x6",
];
const STORAGE_SCOPE = RADIX_API_GATEWAY_URL.includes("stokenet")
  ? "stokenet"
  : "mainnet";
const ACTIVITY_CACHE_VERSION = "v6";
const ACTIVITY_CACHE_KEY = `dckslapActivitySnapshot.${STORAGE_SCOPE}.${ACTIVITY_CACHE_VERSION}`;
const ACTIVITY_CACHE_TTL_MS = 10 * 60 * 1000;
const SOURCE_SYNC_PREFIX = `dckslapActivitySource.${STORAGE_SCOPE}.${ACTIVITY_CACHE_VERSION}`;

const SOURCE_KEYS = {
  globalDeposits: "globalDeposits",
  gamesPlayed: "gamesPlayed",
  ociswapTrades: "ociswapTrades.v2",
  caviarnineTrades: "caviarnineTrades.v3",
  defiplazaTrades: "defiplazaTrades",
  reddicksDexTrades: "reddicksDexTrades",
};

const EMPTY_DATASET = {
  transfers: [],
  mints: [],
};

export const EMPTY_GAMES_PLAYED_STATS = {
  gamePlayed: 0,
  gameWin: 0,
  gameLose: 0,
  winRate: 0,
};

export const EMPTY_ACTIVITY_STATS = {
  dckslapTotalMinted: 0,
  dckslapTotalTransferred: 0,
  gbofTotalMinted: 0,
  gbofTotalTransferred: 0,
  grandTotalMinted: 0,
  grandTotalTransferred: 0,
  grandTotalVolume: 0,
  totalPlayersCount: 0,
  totalParticipants: 0,
  globalDepositCount: 0,
  gamesPlayedCount: 0,
  ociswapTradeCount: 0,
  caviarnineTradeCount: 0,
  defiplazaTradeCount: 0,
  swapsTradeCount: 0,
  reddicksDexTradeCount: 0,
};

let inFlightSnapshotPromise = null;

const isBrowser = typeof window !== "undefined";

const getStoredValue = (key) => {
  if (!isBrowser) return null;
  return window.localStorage.getItem(key);
};

const setStoredValue = (key, value) => {
  if (!isBrowser) return;
  window.localStorage.setItem(key, value);
};

const removeStoredValue = (key) => {
  if (!isBrowser) return;
  window.localStorage.removeItem(key);
};

const parseJson = (value, fallback = null) => {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn("Failed to parse cached activity payload:", error);
    return fallback;
  }
};

const getArrayPayload = (value) =>
  Array.isArray(value?.data) ? value.data : Array.isArray(value) ? value : [];

const fetchJson = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url} (${response.status})`);
  }

  return response.json();
};

const fetchJsonWithFallback = async (urls) => {
  const candidates = Array.from(
    new Set(
      (Array.isArray(urls) ? urls : []).filter(
        (url) => typeof url === "string" && url
      )
    )
  );
  let lastError = null;

  for (const candidate of candidates) {
    try {
      return await fetchJson(candidate);
    } catch (error) {
      lastError = error;
    }
  }

  if (lastError) {
    throw lastError;
  }

  throw new Error("No REDDICKS DEX pair endpoints configured");
};

const fetchTransactionStream = async (requestBody) => {
  const response = await fetch(GATEWAY_TRANSACTION_STREAM_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch transaction stream (${response.status})`
    );
  }

  return response.json();
};

const fetchRadxplorerData = async () => {
  const [dckslapData, gbofData] = await Promise.all([
    fetchJson(RADXPLORER_DCKSLAP_URL),
    fetchJson(RADXPLORER_GBOF_URL),
  ]);

  return {
    dckslapData,
    gbofData,
  };
};

const fetchTotalPlayersCount = async () => {
  const response = await fetch(
    `${RADIX_API_GATEWAY_URL}/state/key-value-store/keys`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        key_value_store_address: CANDY_MACHINE_INTERNAL_USERS_KEY_VALUE_STORE,
      }),
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch player count (${response.status})`);
  }

  const data = await response.json();
  return Number.isFinite(data?.total_count) ? data.total_count : 0;
};

const getSourceSyncStorageKey = (sourceKey) =>
  `${SOURCE_SYNC_PREFIX}.${sourceKey}`;

const normalizeStateVersion = (value) =>
  Number.isFinite(value) ? value : null;

const getSourceSyncState = (sourceKey) =>
  parseJson(getStoredValue(getSourceSyncStorageKey(sourceKey)), null);

const writeSourceSyncState = (sourceKey, state) => {
  setStoredValue(getSourceSyncStorageKey(sourceKey), JSON.stringify(state));
};

const clearSourceSyncState = (sourceKey) => {
  removeStoredValue(getSourceSyncStorageKey(sourceKey));
};

const getSourceSyncAccumulator = (sourceKey) => {
  const sourceSyncState = getSourceSyncState(sourceKey);
  return Number.isFinite(sourceSyncState?.accumulator)
    ? sourceSyncState.accumulator
    : null;
};

const buildAscendingTransactionRequest = ({
  cursor,
  highestProcessedStateVersion,
  atLedgerStateVersion,
  limitPerPage = 500,
  optIns = {},
  ...filters
}) => {
  const requestBody = {
    cursor,
    order: "Asc",
    limit_per_page: limitPerPage,
    transaction_status_filter: "Success",
    opt_ins: {
      receipt_output: false,
      balance_changes: false,
      manifest_instructions: false,
      ...optIns,
    },
    ...filters,
  };

  if (!cursor && Number.isFinite(highestProcessedStateVersion)) {
    requestBody.from_ledger_state = {
      state_version: highestProcessedStateVersion + 1,
    };
  }

  if (Number.isFinite(atLedgerStateVersion)) {
    requestBody.at_ledger_state = {
      state_version: atLedgerStateVersion,
    };
  }

  return requestBody;
};

const syncTransactionAccumulator = async ({
  sourceKey,
  initialAccumulator,
  normalizeAccumulator,
  reduceItem,
  getRequestBody,
  persistedFields = {},
}) => {
  const storedState = getSourceSyncState(sourceKey) || {};
  let accumulator = normalizeAccumulator(storedState.accumulator);
  let cursor =
    typeof storedState.cursor === "string" && storedState.cursor
      ? storedState.cursor
      : null;
  let highestProcessedStateVersion = normalizeStateVersion(
    storedState.highestProcessedStateVersion
  );
  let latestObservedStateVersion = highestProcessedStateVersion;

  if (accumulator == null) {
    accumulator = initialAccumulator;
  }

  do {
    const data = await fetchTransactionStream(
      getRequestBody({
        cursor,
        highestProcessedStateVersion,
      })
    );

    if (Number.isFinite(data?.ledger_state?.state_version)) {
      latestObservedStateVersion = data.ledger_state.state_version;
    }

    if (Array.isArray(data.items)) {
      for (const item of data.items) {
        accumulator = reduceItem(accumulator, item);

        if (Number.isFinite(item?.state_version)) {
          highestProcessedStateVersion = Number.isFinite(
            highestProcessedStateVersion
          )
            ? Math.max(highestProcessedStateVersion, item.state_version)
            : item.state_version;
        }
      }
    }

    cursor = data.next_cursor || null;
    writeSourceSyncState(sourceKey, {
      ...persistedFields,
      accumulator,
      cursor,
      highestProcessedStateVersion,
    });
  } while (cursor);

  const syncStateVersionToPersist = Number.isFinite(
    highestProcessedStateVersion
  )
    ? highestProcessedStateVersion
    : latestObservedStateVersion;

  writeSourceSyncState(sourceKey, {
    ...persistedFields,
    accumulator,
    cursor: null,
    highestProcessedStateVersion: syncStateVersionToPersist,
  });

  return accumulator;
};

const syncTransactionCount = async ({
  sourceKey,
  getRequestBody,
  matchesTransaction,
  persistedFields = {},
}) =>
  syncTransactionAccumulator({
    sourceKey,
    initialAccumulator: 0,
    normalizeAccumulator: (value) => (Number.isFinite(value) ? value : 0),
    reduceItem: (count, item) =>
      count + (matchesTransaction(item) ? 1 : 0),
    getRequestBody,
    persistedFields,
  });

const getManifestSwapComponents = (manifestInstructions) => {
  if (typeof manifestInstructions !== "string") {
    return new Set();
  }

  const componentAddresses = new Set();
  const swapCallPattern =
    /CALL_METHOD\s+Address\("([^"]+)"\)\s+"swap"/g;
  let match = swapCallPattern.exec(manifestInstructions);

  while (match) {
    componentAddresses.add(match[1]);
    match = swapCallPattern.exec(manifestInstructions);
  }

  return componentAddresses;
};

const transactionCallsSwapOnAnyComponent = (item, componentAddresses) => {
  const manifestSwapComponents = getManifestSwapComponents(
    item?.manifest_instructions
  );

  for (const componentAddress of componentAddresses) {
    if (manifestSwapComponents.has(componentAddress)) {
      return true;
    }
  }

  return false;
};

const getTransactionIdentity = (item) =>
  item?.intent_hash || item?.payload_hash || item?.state_version || null;

const normalizeComponentAddresses = (componentAddresses) =>
  Array.from(
    new Set(
      (Array.isArray(componentAddresses) ? componentAddresses : []).filter(
        (componentAddress) =>
          typeof componentAddress === "string" && componentAddress
      )
    )
  );

const isGatewayGlobalEntityAddress = (entityAddress) =>
  typeof entityAddress === "string" &&
  /^(component_|account_|resource_|package_)/.test(entityAddress);

const mergeComponentAddresses = (...componentLists) =>
  normalizeComponentAddresses(componentLists.flat()).sort();

const fetchLatestLedgerStateVersion = async () => {
  const data = await fetchTransactionStream({
    limit_per_page: 1,
    order: "Desc",
    transaction_status_filter: "Success",
    opt_ins: {
      receipt_output: false,
      balance_changes: false,
      manifest_instructions: false,
    },
  });

  return normalizeStateVersion(data?.ledger_state?.state_version);
};

const fetchAllGlobalDeposits = async () =>
  syncTransactionCount({
    sourceKey: SOURCE_KEYS.globalDeposits,
    getRequestBody: ({ cursor, highestProcessedStateVersion }) =>
      buildAscendingTransactionRequest({
        cursor,
        highestProcessedStateVersion,
        optIns: {
          balance_changes: true,
        },
        manifest_badges_presented_filter: [DCKSLAP_USER_BADGE_RESOURCE_ADDRESS],
        events_filter: [
          {
            event: "Withdrawal",
            resource_address: DCKSLAP_RESOURCE_ADDRESS,
          },
        ],
        affected_global_entities_filter: [DCKSLAP_COMPONENT_ADDRESS],
      }),
    matchesTransaction: () => true,
  });

const fetchGamesPlayedStats = async () => {
  const rawStats = await syncTransactionAccumulator({
    sourceKey: SOURCE_KEYS.gamesPlayed,
    initialAccumulator: {
      gamePlayed: 0,
      gameWin: 0,
    },
    normalizeAccumulator: (value) => ({
      gamePlayed: Number.isFinite(value?.gamePlayed) ? value.gamePlayed : 0,
      gameWin: Number.isFinite(value?.gameWin) ? value.gameWin : 0,
    }),
    getRequestBody: ({ cursor, highestProcessedStateVersion }) =>
      buildAscendingTransactionRequest({
        cursor,
        highestProcessedStateVersion,
        optIns: {
          balance_changes: true,
          manifest_instructions: true,
        },
        manifest_badges_presented_filter: [CANDY_MACHINE_BOT_BADGE_ADDRESS],
      }),
    reduceItem: (statsAccumulator, item) => {
      if (
        typeof item?.manifest_instructions !== "string" ||
        item.manifest_instructions.lastIndexOf("send_candies") === -1
      ) {
        return statsAccumulator;
      }

      const nextStats = {
        ...statsAccumulator,
        gamePlayed: statsAccumulator.gamePlayed + 1,
      };

      const fungibleChanges = item.balance_changes?.fungible_balance_changes;
      if (Array.isArray(fungibleChanges) && fungibleChanges.length > 0) {
        nextStats.gameWin += 1;
      }

      return nextStats;
    },
  });

  return {
    gamePlayed: rawStats.gamePlayed,
    gameWin: rawStats.gameWin,
    gameLose: rawStats.gamePlayed - rawStats.gameWin,
    winRate:
      rawStats.gamePlayed > 0 ? rawStats.gameWin / rawStats.gamePlayed : 0,
  };
};

const isMainnetVenueSource = STORAGE_SCOPE === "mainnet";

const fetchSwapTradeCountForComponents = async ({
  sourceKey,
  componentAddresses,
  transactionEntityAddresses = componentAddresses,
  seedAccumulator = 0,
  seedStateVersion = null,
}) => {
  const normalizedComponents = normalizeComponentAddresses(
    componentAddresses
  ).sort();
  const normalizedTransactionEntities = mergeComponentAddresses(
    normalizeComponentAddresses(transactionEntityAddresses).filter(
      isGatewayGlobalEntityAddress
    ),
    normalizeComponentAddresses(componentAddresses).filter(
      isGatewayGlobalEntityAddress
    )
  );
  const targetSignature = [
    normalizedTransactionEntities.join(","),
    normalizedComponents.join(","),
  ].join("|");
  const storedState = getSourceSyncState(sourceKey);
  const storedAccumulator = Number.isFinite(storedState?.accumulator)
    ? storedState.accumulator
    : 0;
  const storedStateVersion = normalizeStateVersion(
    storedState?.highestProcessedStateVersion
  );
  const hasTargetSignatureChanged =
    storedState?.targetSignature !== targetSignature;
  const hasUsableStoredState =
    !hasTargetSignatureChanged && Number.isFinite(storedStateVersion);

  if (hasTargetSignatureChanged) {
    clearSourceSyncState(sourceKey);
  }

  const baseAccumulator = hasUsableStoredState
    ? storedAccumulator
    : seedAccumulator;
  const baseStateVersion = hasUsableStoredState
    ? storedStateVersion
    : normalizeStateVersion(seedStateVersion);

  if (
    normalizedComponents.length === 0 ||
    normalizedTransactionEntities.length === 0
  ) {
    writeSourceSyncState(sourceKey, {
      targetSignature,
      accumulator: 0,
      cursor: null,
      highestProcessedStateVersion: null,
    });
    return 0;
  }

  const targetLedgerStateVersion = await fetchLatestLedgerStateVersion();
  if (!Number.isFinite(targetLedgerStateVersion)) {
    throw new Error(`Failed to determine ledger state for ${sourceKey}`);
  }

  if (
    Number.isFinite(baseStateVersion) &&
    Number.isFinite(targetLedgerStateVersion) &&
    baseStateVersion >= targetLedgerStateVersion
  ) {
    writeSourceSyncState(sourceKey, {
      targetSignature,
      accumulator: baseAccumulator,
      cursor: null,
      highestProcessedStateVersion: baseStateVersion,
    });
    return baseAccumulator;
  }

  const swapComponentSet = new Set(normalizedComponents);
  const matchedTransactionIds = new Set();

  for (const transactionEntityAddress of normalizedTransactionEntities) {
    let cursor = null;

    do {
      const data = await fetchTransactionStream(
        buildAscendingTransactionRequest({
          cursor,
          highestProcessedStateVersion: baseStateVersion,
          atLedgerStateVersion: targetLedgerStateVersion,
          optIns: {
            manifest_instructions: true,
          },
          // Gateway treats this filter as an intersection, not a union.
          // Query one entity per request and de-duplicate transaction ids across entities.
          affected_global_entities_filter: [transactionEntityAddress],
        })
      );

      if (Array.isArray(data.items)) {
        for (const item of data.items) {
          const transactionId = getTransactionIdentity(item);
          if (!transactionId || matchedTransactionIds.has(transactionId)) {
            continue;
          }

          if (transactionCallsSwapOnAnyComponent(item, swapComponentSet)) {
            matchedTransactionIds.add(transactionId);
          }
        }
      }

      cursor = data.next_cursor || null;
    } while (cursor);
  }

  const nextAccumulator = baseAccumulator + matchedTransactionIds.size;

  writeSourceSyncState(sourceKey, {
    targetSignature,
    accumulator: nextAccumulator,
    cursor: null,
    highestProcessedStateVersion:
      targetLedgerStateVersion ?? baseStateVersion,
  });

  return nextAccumulator;
};

const fetchOciswapPoolComponents = async () => {
  if (!isMainnetVenueSource) {
    return [];
  }

  try {
    const pools = getArrayPayload(await fetchJson(OCISWAP_POOLS_URL));
    const discoveredComponents = pools
      .filter((pool) => {
        const xTokenAddress = pool?.x?.token?.address;
        const yTokenAddress = pool?.y?.token?.address;

        return (
          xTokenAddress === REDDICKS_RESSOURCE_ADDRESS ||
          yTokenAddress === REDDICKS_RESSOURCE_ADDRESS
        );
      })
      .map((pool) => pool?.address || pool?.liquidity_pool_address);

    return mergeComponentAddresses(
      VERIFIED_OCISWAP_DCKS_POOL_COMPONENTS,
      discoveredComponents
    );
  } catch (error) {
    console.warn(
      "Failed to discover Ociswap DCKS pools, using verified fallback:",
      error
    );
    return VERIFIED_OCISWAP_DCKS_POOL_COMPONENTS;
  }
};

const getVerifiedCaviarnineSwapTargets = () =>
  VERIFIED_CAVIARNINE_DCKS_SWAP_TARGETS.map((target) => ({ ...target }));

const fetchReddicksDexPairComponents = async () => {
  if (!isMainnetVenueSource) {
    return [];
  }

  const pairs = getArrayPayload(
    await fetchJsonWithFallback(getReddicksDexPairsCandidateUrls())
  );

  return Array.from(
    new Set(
      pairs
        .filter((pair) => {
          if (!pair?.address) {
            return false;
          }

          const isDcksPair =
            pair.baseToken === REDDICKS_RESSOURCE_ADDRESS ||
            pair.quoteToken === REDDICKS_RESSOURCE_ADDRESS;

          if (!isDcksPair) {
            return false;
          }

          return (
            !pair.dexAddress ||
            pair.dexAddress === REDDICKS_DEX_ROUTER_COMPONENT
          );
        })
        .map((pair) => pair.address)
    )
  ).sort();
};

const fetchOciswapTradeCount = async () =>
  fetchSwapTradeCountForComponents({
    sourceKey: SOURCE_KEYS.ociswapTrades,
    componentAddresses: await fetchOciswapPoolComponents(),
    seedAccumulator: OCISWAP_DCKS_SEED_TRADE_COUNT,
    seedStateVersion: OCISWAP_DCKS_SEED_STATE_VERSION,
  });

const fetchCaviarnineTradeCount = async () => {
  const swapTargets = getVerifiedCaviarnineSwapTargets();
  const componentAddresses = swapTargets.map(
    (target) => target.componentAddress
  );
  const transactionEntityAddresses = swapTargets.map(
    (target) => target.transactionEntityAddress
  );

  return fetchSwapTradeCountForComponents({
    sourceKey: SOURCE_KEYS.caviarnineTrades,
    componentAddresses,
    transactionEntityAddresses,
    seedAccumulator: CAVIARNINE_DCKS_SEED_TRADE_COUNT,
    seedStateVersion: CAVIARNINE_DCKS_SEED_STATE_VERSION,
  });
};

const fetchDefiplazaTradeCount = async () =>
  fetchSwapTradeCountForComponents({
    sourceKey: SOURCE_KEYS.defiplazaTrades,
    componentAddresses: VERIFIED_DEFIPLAZA_DCKS_PAIR_COMPONENTS,
  });

const fetchReddicksDexTradeCount = async () => {
  if (!isMainnetVenueSource) {
    return 0;
  }

  const pairComponents = await fetchReddicksDexPairComponents();
  return fetchSwapTradeCountForComponents({
    sourceKey: SOURCE_KEYS.reddicksDexTrades,
    componentAddresses: pairComponents,
  });
};

const fetchVenueTradeStats = async () => {
  if (!isMainnetVenueSource) {
    return {
      ociswapTradeCount: 0,
      caviarnineTradeCount: 0,
      defiplazaTradeCount: 0,
      reddicksDexTradeCount: 0,
    };
  }

  const settleVenueCount = async (label, fetcher) => {
    try {
      return await fetcher();
    } catch (error) {
      console.warn(`Failed to refresh ${label}:`, error);
      return 0;
    }
  };

  const [
    ociswapTradeCount,
    caviarnineTradeCount,
    defiplazaTradeCount,
    reddicksDexTradeCount,
  ] = await Promise.all([
    settleVenueCount("Ociswap swap count", () => fetchOciswapTradeCount()),
    settleVenueCount("CaviarNine swap count", () =>
      fetchCaviarnineTradeCount()
    ),
    settleVenueCount("Astrolescent / DefiPlaza swap count", () =>
      fetchDefiplazaTradeCount()
    ),
    settleVenueCount("REDDICKS DEX trade count", () =>
      fetchReddicksDexTradeCount()
    ),
  ]);

  return {
    ociswapTradeCount,
    caviarnineTradeCount,
    defiplazaTradeCount,
    reddicksDexTradeCount,
  };
};

export const buildActivityStats = ({
  dckslapData = EMPTY_DATASET,
  gbofData = EMPTY_DATASET,
  totalPlayersCount = 0,
  globalDepositCount = 0,
  gamesPlayedStats = EMPTY_GAMES_PLAYED_STATS,
  ociswapTradeCount = 0,
  caviarnineTradeCount = 0,
  defiplazaTradeCount = 0,
  reddicksDexTradeCount = 0,
}) => {
  let dckslapTotalMinted = 0;
  let dckslapTotalTransferred = 0;
  const dckslapParticipants = new Set();

  if (Array.isArray(dckslapData.mints)) {
    dckslapData.mints.forEach((mint) => {
      dckslapTotalMinted += mint.amount || 0;

      if (mint.accounts && typeof mint.accounts === "object") {
        Object.keys(mint.accounts).forEach((address) => {
          dckslapParticipants.add(address);
        });
      }
    });
  }

  if (Array.isArray(dckslapData.transfers)) {
    dckslapData.transfers.forEach((transfer) => {
      dckslapTotalTransferred += transfer.amount || 0;

      if (transfer.accountsReceived && typeof transfer.accountsReceived === "object") {
        Object.keys(transfer.accountsReceived).forEach((address) => {
          dckslapParticipants.add(address);
        });
      }

      if (transfer.accountsSent && typeof transfer.accountsSent === "object") {
        Object.keys(transfer.accountsSent).forEach((address) => {
          dckslapParticipants.add(address);
        });
      }
    });
  }

  let gbofTotalMinted = 0;
  let gbofTotalTransferred = 0;

  if (Array.isArray(gbofData.mints)) {
    gbofData.mints.forEach((mint) => {
      gbofTotalMinted += mint.amount || 0;
    });
  }

  if (Array.isArray(gbofData.transfers)) {
    gbofData.transfers.forEach((transfer) => {
      gbofTotalTransferred += transfer.amount || 0;
    });
  }

  const swapsTradeCount =
    ociswapTradeCount + caviarnineTradeCount + defiplazaTradeCount;
  const grandTotalMinted = dckslapTotalMinted + gbofTotalMinted;
  const grandTotalTransferred = dckslapTotalTransferred + gbofTotalTransferred;
  const gamesPlayedContribution = (gamesPlayedStats.gamePlayed || 0) * 2;
  const grandTotalVolume =
    grandTotalMinted +
    grandTotalTransferred +
    globalDepositCount +
    gamesPlayedContribution +
    swapsTradeCount +
    reddicksDexTradeCount;

  return {
    dckslapTotalMinted,
    dckslapTotalTransferred,
    gbofTotalMinted,
    gbofTotalTransferred,
    grandTotalMinted,
    grandTotalTransferred,
    grandTotalVolume,
    totalPlayersCount,
    totalParticipants: dckslapParticipants.size,
    globalDepositCount,
    gamesPlayedCount: gamesPlayedStats.gamePlayed || 0,
    ociswapTradeCount,
    caviarnineTradeCount,
    defiplazaTradeCount,
    swapsTradeCount,
    reddicksDexTradeCount,
  };
};

const normalizeSnapshot = (snapshot) => {
  if (!snapshot || typeof snapshot !== "object") {
    return null;
  }

  const dckslapData = snapshot.dckslapData || EMPTY_DATASET;
  const gbofData = snapshot.gbofData || EMPTY_DATASET;
  const gamesPlayedStats = snapshot.gamesPlayedStats || EMPTY_GAMES_PLAYED_STATS;
  const totalPlayersCount =
    snapshot.totalPlayersCount ??
    snapshot.stats?.totalPlayersCount ??
    snapshot.stats?.totalParticipants ??
    0;
  const globalDepositCount = snapshot.globalDepositCount || 0;
  const liveOciswapTradeCount = getSourceSyncAccumulator(
    SOURCE_KEYS.ociswapTrades
  );
  const liveCaviarnineTradeCount = getSourceSyncAccumulator(
    SOURCE_KEYS.caviarnineTrades
  );
  const liveDefiplazaTradeCount = getSourceSyncAccumulator(
    SOURCE_KEYS.defiplazaTrades
  );
  const liveReddicksDexTradeCount = getSourceSyncAccumulator(
    SOURCE_KEYS.reddicksDexTrades
  );
  const ociswapTradeCount =
    Math.max(
      snapshot.ociswapTradeCount ?? snapshot.stats?.ociswapTradeCount ?? 0,
      liveOciswapTradeCount ?? 0
    );
  const caviarnineTradeCount =
    Math.max(
      snapshot.caviarnineTradeCount ??
        snapshot.stats?.caviarnineTradeCount ??
        0,
      liveCaviarnineTradeCount ?? 0
    );
  const defiplazaTradeCount =
    Math.max(
      snapshot.defiplazaTradeCount ?? snapshot.stats?.defiplazaTradeCount ?? 0,
      liveDefiplazaTradeCount ?? 0
    );
  const reddicksDexTradeCount =
    Math.max(
      snapshot.reddicksDexTradeCount ??
        snapshot.stats?.reddicksDexTradeCount ??
        0,
      liveReddicksDexTradeCount ?? 0
    );

  return {
    dckslapData,
    gbofData,
    gamesPlayedStats,
    totalPlayersCount,
    globalDepositCount,
    ociswapTradeCount,
    caviarnineTradeCount,
    defiplazaTradeCount,
    reddicksDexTradeCount,
    stats: buildActivityStats({
      dckslapData,
      gbofData,
      totalPlayersCount,
      globalDepositCount,
      gamesPlayedStats,
      ociswapTradeCount,
      caviarnineTradeCount,
      defiplazaTradeCount,
      reddicksDexTradeCount,
    }),
    fetchedAt: snapshot.fetchedAt || null,
    isFresh: Boolean(snapshot.isFresh),
  };
};

export const getCachedDckslapActivitySnapshot = () => {
  const cached = normalizeSnapshot(parseJson(getStoredValue(ACTIVITY_CACHE_KEY)));
  if (!cached?.fetchedAt) {
    return null;
  }

  const fetchedAtMs = Date.parse(cached.fetchedAt);
  return {
    ...cached,
    isFresh: Number.isFinite(fetchedAtMs) && Date.now() - fetchedAtMs < ACTIVITY_CACHE_TTL_MS,
  };
};

const writeCachedSnapshot = (snapshot) => {
  setStoredValue(ACTIVITY_CACHE_KEY, JSON.stringify(snapshot));
};

const settleSnapshotSection = async (label, fetcher, fallbackValue) => {
  try {
    return await fetcher();
  } catch (error) {
    console.warn(`Failed to refresh ${label}:`, error);
    return fallbackValue;
  }
};

export const fetchDckslapActivitySnapshot = async () => {
  if (inFlightSnapshotPromise) {
    return inFlightSnapshotPromise;
  }

  inFlightSnapshotPromise = (async () => {
    const cachedSnapshot = getCachedDckslapActivitySnapshot();
    const [
      { dckslapData, gbofData },
      totalPlayersCount,
      globalDepositCount,
      gamesPlayedStats,
      {
        ociswapTradeCount,
        caviarnineTradeCount,
        defiplazaTradeCount,
        reddicksDexTradeCount,
      },
    ] = await Promise.all([
      settleSnapshotSection("Radxplorer activity data", () => fetchRadxplorerData(), {
        dckslapData: cachedSnapshot?.dckslapData || EMPTY_DATASET,
        gbofData: cachedSnapshot?.gbofData || EMPTY_DATASET,
      }),
      settleSnapshotSection(
        "player count",
        () => fetchTotalPlayersCount(),
        cachedSnapshot?.totalPlayersCount ??
          cachedSnapshot?.stats?.totalPlayersCount ??
          0
      ),
      settleSnapshotSection(
        "global deposits",
        () => fetchAllGlobalDeposits(),
        cachedSnapshot?.globalDepositCount ??
          cachedSnapshot?.stats?.globalDepositCount ??
          0
      ),
      settleSnapshotSection(
        "games played stats",
        () => fetchGamesPlayedStats(),
        cachedSnapshot?.gamesPlayedStats || EMPTY_GAMES_PLAYED_STATS
      ),
      settleSnapshotSection("venue trade stats", () => fetchVenueTradeStats(), {
        ociswapTradeCount: cachedSnapshot?.ociswapTradeCount ?? 0,
        caviarnineTradeCount: cachedSnapshot?.caviarnineTradeCount ?? 0,
        defiplazaTradeCount: cachedSnapshot?.defiplazaTradeCount ?? 0,
        reddicksDexTradeCount: cachedSnapshot?.reddicksDexTradeCount ?? 0,
      }),
    ]);

    const snapshot = {
      dckslapData,
      gbofData,
      totalPlayersCount,
      globalDepositCount,
      gamesPlayedStats,
      ociswapTradeCount,
      caviarnineTradeCount,
      defiplazaTradeCount,
      reddicksDexTradeCount,
      stats: buildActivityStats({
        dckslapData,
        gbofData,
        totalPlayersCount,
        globalDepositCount,
        gamesPlayedStats,
        ociswapTradeCount,
        caviarnineTradeCount,
        defiplazaTradeCount,
        reddicksDexTradeCount,
      }),
      fetchedAt: new Date().toISOString(),
    };

    writeCachedSnapshot(snapshot);
    return {
      ...normalizeSnapshot(snapshot),
      isFresh: true,
    };
  })();

  try {
    return await inFlightSnapshotPromise;
  } finally {
    inFlightSnapshotPromise = null;
  }
};
